import React from "react";
// import React, { useContext, useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router";
import classes from "./CardWhite.module.scss";
// import dashboard01 from "./../../../assets/images/dashboard_images/img_dash_01.svg";

interface Interface {
  title?: string;
  img?: any;
  number?: number;
  numberDesc?: string;
  showInfo?: string;
  open?: any;
  setOpen?: any;
  setIndexCardWhite?: any;
  setIndexCardBlue?: any;
  setOpenCountPlay?: any;
  openCountPlay?: any;
  index?: any;
  indexCardWhite?: any;
}

const CardWhite = ({
  title,
  img,
  number,
  numberDesc,
  showInfo,
  setOpen,
  open,
  setIndexCardWhite,
  setIndexCardBlue,
  index,
}: Interface) => {

  return (
    <div
      onClick={() => {
        setIndexCardWhite(index);
        setOpen(!open);
        setIndexCardBlue(null);
      }}
      className={classes.CardWhite}
    >
      <div className={classes.CardTop}>
        <div className={classes.Title}>{title}</div>
      </div>
      <div className={classes.CardBottom}>
        <div className={classes.CardBottomLeft}>
          <div className={classes.CardNumberArea}>
            <div className={classes.UsersNumber}>{number}</div>
            <div className={classes.DescName}>{numberDesc}</div>
          </div>

          <div className={classes.SeeUsers}>{showInfo}</div>
        </div>
        <img className={classes.Image} src={img} alt="" />
      </div>
    </div>
  );
};

export default CardWhite;
